import secureLocalStorage from "react-secure-storage";
import React, { PureComponent } from "react";
import "../../Styles/RiskViews.scss";
import {
  Grid,
  GridColumn as Column,
  GridNoRecords,
} from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import CurrencyFormat from "../Tenant/Component/CurrencyFormat";
import { formatNumber } from "@telerik/kendo-intl";
import * as moment from "moment";
import Api from "../../Services/Api";
import { filterBy } from "@progress/kendo-data-query";
import ColumnMenuFilterForTask from "./ColumnMenuFilterForTask";
import { ColumnMenuCheckboxFilter } from "../Dashboard/ColumnMenuCheckboxFilter";
import { CustomFieldSearchMenuForAction } from "../Dashboard/CustomFieldSearchMenuForAction";
import { SingleDropDownCheckboxFilter } from "../Dashboard/SingleDropDownCheckboxFilter";
export default class ViewActivitiesDataset extends PureComponent {
  constructor(props) {
    super(props);
    this.state = this.createAppState({
      ...this.state,
      sort: [{ field: "code", dir: "asc" }],
      take: 10,
      skip: 0,
      taskDataList: [],
      impactMaster: [],
      // dropdownColumn:[],
      customFieldsmaster: [],
      riskTypemaster: [],
      taskDataListTemp: [],
      selectedIds: [],
      existingFilter: [],
      selectedColumn: undefined,
      filter: {
        logic: "and",
        filters: [],
      },
    });
  }
  componentDidMount() {
    this.init();
  }
  init = async () => {
    await this.getCustomField();
  };
  componentDidUpdate(prevProps) {
    if (this.props.taskDataList !== prevProps.taskDataList) {
      this.createDynamicDropdowns(this.props.taskDataList);
    //   this.createDynamicCols(this.props.taskDataList);
    }
  }
  //trigger method by parent
  refreshData = (data) => {
    // this.createDynamicCols(data);
    this.createDynamicDropdowns(data);
  };

 
  createDynamicCols = async (products) => {
    try{
      let impactMaster = [];
      if (products && products.length > 0) {
        impactMaster = products[0].impactResponse;
      }
  
      let impactColumn = [];
  
      products.map((res, i) => {
        if (res.impactResponse) {
          res.impactResponse.map((item, j) => {
            if (impactColumn.length > 0) {
              if (!impactColumn.includes(item.name)) {
                impactColumn.push(item.name);
              }
            } else {
              impactColumn.push(item.name);
            }
          });
        }
      });
      
      if (impactColumn.length > 0) {
        products.map((res) => {
          impactColumn.map((col) => {
            let temp = res.impactResponse.find((item) => item.name === col);
            if (temp) {
              res[col] =temp.impactType == "Quantitative" ? temp.value : temp.qValue;
            } else {
              res[col] = undefined;;
            }
          });
        });
      }
      let columnsToShow = [];
      if (impactColumn.length > 0) {
        columnsToShow = impactColumn.map((item) => (
          <Column
            field={ item }
            title={'Change in '+this.getImpactUnit(item,impactMaster)}
            width="100px"
            editable={ false }
            filter={'numeric'}
            columnMenu={(props) => (
              <ColumnMenuFilterForTask
                {...props}
                getSelectedColumn={this.getSelectedColumn}
              />
            )}
            cell={(props) => (<CurrencyFormat { ...props } onEditCell={this.onEditCell}/>)}
          />
        ));
      }
      //  setImpactColumns(columnsToShow);
      this.setState({ ...this.state, impactColumns: columnsToShow ,taskDataList:products,taskDataListTemp:products});
    
    }catch(err){
      console.log(err)
    }
    };
  createDynamicDropdowns = async (products, filter) => {
    let dropdownColumn = [];
    products.map((res, i) => {
      res.customFields &&
        res.customFields.map((item, j) => {
          if (dropdownColumn.length > 0) {
            if (!dropdownColumn.find((cf) => cf.fieldName === item.fieldName)) {
              dropdownColumn.push({
                fieldName: item.fieldName,
                data: this.getCustomFieldMasterData(item.fieldName, filter),
                inputType: this.getInputType(item.fieldName),
              });
            }
          } else {
            dropdownColumn.push({
              fieldName: item.fieldName,
              data: this.getCustomFieldMasterData(item.fieldName, filter),
              inputType: this.getInputType(item.fieldName),
            });
          }
          return item;
        });

      return res;
    });

    if (dropdownColumn.length > 0) {
      products.map((res) => {
        dropdownColumn.map((col) => {
          let temp = res.customFields.find(
            (item) => item.fieldName === col.fieldName
          );
          if (temp) {
            if (temp.inputType === "Multi Drop Down") {
              let val = temp.selectedCustomFieldNames
                ? temp.selectedCustomFieldNames.toString()
                : "";
              let hashArr = this.stringToHashForCF(val, col.data);
              res[col.fieldName] = hashArr;
            } else if (temp.inputType === "Single Drop Down") {
              let val =
                temp.selectedCustomFieldNames &&
                temp.selectedCustomFieldNames.length > 0
                  ? temp.selectedCustomFieldNames.toString()
                  : null;
              res[col.fieldName] = val;
            } else if (temp.inputType === "Free Text") {
              let val =
                temp.multiText && temp.multiText != "" ? temp.multiText : null;
              res[col.fieldName] = val;
            } else if (temp.inputType === "Numeric") {
              let val =
                temp.multiText && temp.multiText != ""
                  ? parseInt(temp.multiText)
                  : null;
              res[col.fieldName] = val;
            } else if (temp.inputType === "Date") {
              let val =
                temp.multiText && temp.multiText != ""
                  ? new Date(temp.multiText)
                  : null;
              res[col.fieldName] = val;
            }
          } else {
            res[col.fieldName] = "";
          }
          return col;
        });
        return res;
      });
    }
    let columnsToShow = [];
    if (dropdownColumn.length > 0) {
      columnsToShow = dropdownColumn.map((item) => {
        return (
          <Column
            field={item.fieldName}
            title={item.fieldName}
            width="150px"
            cell={(props) =>
              this.viewMultiselectColsCustomDropdown(props, item)
            }
            columnMenu={(props) => this.getCustomFieldColumnMenu(props, item)}
            filter={this.getCustomFieldFilter(item)}
            headerClassName={
              this.checkItsinFilterOrNot(item.fieldName, filter) ? "active" : ""
            }
          />
        );
      });
    }
    this.setState({
      ...this.state,
      dropdownColumns: columnsToShow,
      taskDataList:products,
      taskDataListTemp:products
    });
  };
  getSelectedColumn = (col) => {
    if (col != this.state.selectedColumn) {
      this.setState({ ...this.state, selectedColumn: col });
    }
  };
  getCustomField = async () => {
    let res = [];
    try {
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };

      let response = await Api.getCustomField(request);
      if (response.status === 200) {
        response.customFields.map((item) => {
          item.cfPossibleValues.map((item1) => {
            item1["hashValue"] = this.convertStrToHash(item1.possibleValues);
          });
          if (item.inputType == "Multi Drop Down") {
            let newFirstElement = {
              hashValue: "",
              id: 0,
              possibleValues: " [blank]",
            };

            item["cfPossibleValues"] = [newFirstElement].concat(
              item.cfPossibleValues
            );
            item["possibleValues"] = [" [blank]"].concat(item.possibleValues);
          }
        });
        this.setState({
          ...this.state,
          customFieldsmaster: response.customFields,
        });
      }
    } catch (err) {
      console.error("Exception:", err);
    }
    return res;
  };
  convertStrToHash = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      let char = str.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash;
    }
    hash = Math.abs(hash).toString();
    return hash;
  };
  getCustomFieldMasterData = (fieldName, filter) => {
    try {
      let arr = this.state.customFieldsmaster.filter(
        (item) => item.fieldName == fieldName
      );
      if (arr && arr.length > 0) {
        let temp = [];
        arr[0].cfPossibleValues.map((item, index) => {
          let checked = this.checkCFinFilterValuesOrNot(
            fieldName,
            item.hashValue,
            filter
          );
          temp.push({
            id: index,
            name: item.possibleValues,
            checked: checked,
            hashValue: item.hashValue,
          });
        });
        return temp;
      } else {
        return [];
      }
    } catch (err) {
      return [];
    }
  };
  checkCFinFilterValuesOrNot = (field, value, exfilter) => {
    let flag = false;
    try {
      if (exfilter) {
        exfilter.map((filter) => {
          if (filter.field === field && filter.value == value) {
            flag = true;
          }
          if (filter.filters) {
            filter.filters.map((innerFilter) => {
              if (innerFilter.field === field && innerFilter.value == value) {
                flag = true;
              }
            });
          }
        });
      }
    } catch (err) {
      return flag;
    }
    return flag;
  };
  getInputType = (fieldName) => {
    try {
      let arr = this.state.customFieldsmaster.find(
        (item) => item.fieldName == fieldName
      );
      console.log("arr", arr);
      if (arr) {
        return arr.inputType;
      } else {
        return undefined;
      }
    } catch (err) {
      console.log(err);
    }
  };
  viewMultiselectColsCustomDropdown = (event, cfObj) => {
    let data = cfObj.data;
    let value = event.dataItem[event.field];

    if (cfObj && cfObj.inputType === "Multi Drop Down") {
      let temp = [];
      if (value && value.includes(",")) {
        let arr = value.split(",");
        arr &&
          arr.map((item1, i) => {
            let originalValue = data.find((item) => item.hashValue === item1);
            if (originalValue) {
              temp.push(originalValue.name);
            }
          });
      } else {
        let originalValue = data.find((item) => item.hashValue === value);
        if (originalValue && originalValue.name != " [blank]") {
          temp.push(originalValue.name);
        }
      }
      return <td title={temp.toString()}>{temp.toString()}</td>;
    } else if (cfObj && cfObj.inputType === "Single Drop Down") {
      return (
        <td title={value ? value.toString() : ""}>
          {value ? value.toString() : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Free Text") {
      return (
        <td title={value ? value.toString() : ""}>
          {value ? value.toString() : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Numeric") {
      return (
        <td
          title={
            value || value === 0 ? formatNumber(parseInt(value), "##,#") : ""
          }
        >
          {value || value === 0 ? formatNumber(parseInt(value), "##,#") : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Date") {
      return (
        <td title={value ? moment(value).format("DD-MMM-YYYY") : ""}>
          {value ? moment(value).format("DD-MMM-YYYY") : ""}
        </td>
      );
    } else {
      return <td></td>;
    }
  };
  getImpactUnit = (impact,impactMaster) => {
    
    var res = impact;
    var impactTemp = impactMaster.find(
      (item) => item.name == impact
    );
    
    if (impactTemp && impactTemp.name) {
      res = impactTemp.name + " / " + impactTemp.units;
    }
    return res;
  };
  stringToHashForCF(stringArr, data) {
    let hashArr = [];
    if (stringArr && stringArr.includes(",")) {
      let valArr = stringArr.split(",");
      valArr &&
        valArr.map((item1) => {
          let cfVal = data.find((item) => item.name == item1);
          if (cfVal) {
            hashArr.push(cfVal.hashValue);
          }
        });
    } else {
      let cfVal = data.find((item) => item.name == stringArr);
      if (cfVal) {
        hashArr.push(cfVal.hashValue);
      }
    }
    return hashArr.toString();
  }
  getCustomFieldColumnMenu = (props, item) => {
    if (item.inputType === "Multi Drop Down") {
      return (
        <CustomFieldSearchMenuForAction
          {...props}
          customFieldsmaster={item.data}
          existingFilter={this.state.existingFilter}
          filterChangeV={this.filterChangeV}
          clearFilter={this.clearFilter}
        />
      );
    } else if (item.inputType === "Single Drop Down") {
      return (
        <SingleDropDownCheckboxFilter
          {...props}
          filterData={item.data}
          existingFilter={this.state.existingFilter}
          filterChangeV={this.filterChangeV}
          clearFilter={this.clearFilter}
        />
      );
    } else {
      return (
        <ColumnMenuFilterForTask
          {...props}
          getSelectedColumn={this.getSelectedColumn}
        />
      );
    }
  };
  clearFilter = async (e) => {
    try {
      let filter = e ? e : [];
      const result = filterBy(this.props.taskDataListTemp, filter);
      await this.createDynamicDropdowns(result, filter);
    //   await this.createDynamicCols(result, filter);
    //   await this.checkRisktypeSelections(filter);
      var taskDataList = result.map((dataItem) =>
        Object.assign({ selected: false }, dataItem)
      );
      this.setState({
        ...this.state,
        taskDataList: taskDataList,
        existingFilter: filter,
        take: Math.round((window.innerHeight - 250) / 35),
        skip: 0,
        sort: [],
        filter: {
          logic: "and",
          filters: filter,
        },
      });
      this.saveSelectedIds([]);
      this.props.mitigationFilterQuery(filter);
    } catch (err) {
      console.error(err);
    }
  };
  saveSelectedIds = (data) => {
    let listOfIds = [];
    for (let row of Object.values(data)) {
      if (row.selected) {
        listOfIds.push(row.riskRegisterActionId);
      }
    }
    this.setState({ selectedIds: listOfIds });
    this.props.getSelectedIds(listOfIds);
  };
  getCustomFieldFilter = (item) => {
    if (item.inputType === "Multi Drop Down") {
      return "";
    } else if (item.inputType === "Single Drop Down") {
      return "text";
    } else if (item.inputType === "Free Text") {
      return "";
    } else if (item.inputType === "Numeric") {
      return "numeric";
    } else if (item.inputType === "Date") {
      return "date";
    } else {
      return "";
    }
  };
  checkRisktypeSelections = (exfilter) => {
    let temp = [];
    this.props.riskTypemaster.map((item) => {
      let checked = this.checkCFinFilterValuesOrNot(
        "riskTypeNames",
        item.hashValue,
        exfilter
      );
      item["checked"] = checked;
      temp.push(item);
    });
    this.setState({ ...this.state, riskTypemaster: temp });
  };
  filterChangeV = async (e, colname) => {
    try {
      let exi = []; // this.state.existingFilter;
      if (this.state.existingFilter) {
        let filterData = this.state.existingFilter;
        filterData.map((filter2) => {
          if (filter2.filters) {
            filter2.filters.map((innerFilter) => {
              if (innerFilter.field != colname) {
                exi.push(filter2);
              }
            });
          } else {
            if (filter2.field != colname) {
              exi.push(filter2);
            }
          }
        });
      }

      let filter = e ? e.filters : [];
      let temp = [];
      if (filter.length > 0) {
        temp = [
          {
            filters: filter,
            logic: "or",
          },
        ];
      }

      let arr = [...exi, ...temp];
      const result = filterBy(this.state.taskDataListTemp, arr);
      if (result && result.length > 0) {
        await this.createDynamicDropdowns(result, arr);
        // await this.createDynamicCols(result, arr);
        // await this.checkRisktypeSelections(arr);
      }

      var taskDataList = result.map((dataItem) =>
        Object.assign({ selected: false }, dataItem)
      );
      this.setState({
        ...this.state,
        taskDataList: taskDataList,
        existingFilter: arr,
        take: Math.round((window.innerHeight - 250) / 35),
        skip: 0,
        sort: [],
        filter: {
          logic: "and",
          filters: arr,
        },
      });
      this.saveSelectedIds([]);
      this.props.mitigationFilterQuery(arr);
    } catch (err) {
      console.error(err);
    }
  };
  checkItsinFilterOrNot = (fieldKey, exfilter) => {
    let field = typeof fieldKey === "string" ? fieldKey : fieldKey.fieldName;
    let headerClassName = false;
    try {
      if (exfilter) {
        exfilter.map((filter) => {
          if (filter.field === field) {
            headerClassName = true;
          }
          if (filter.filters) {
            filter.filters.map((innerFilter) => {
              if (innerFilter.field === field) {
                headerClassName = true;
              }
            });
          }
        });
        return headerClassName;
      }
    } catch (err) {
      return headerClassName;
    }
  };
  pageChange = (event) => {
    this.setState({
      skip: event.page.skip,
      take: event.page.take,
    });
  };
  filterChangeExisting = async (e) => {
    if (e.nativeEvent.type == "submit") {
      // let existingFilter = await this.removeSelectedFilterInExisting();
      let existingFilter = this.state.existingFilter
        ? this.state.existingFilter
        : [];
      let filter = e.filter ? e.filter.filters : [];

      // Get the field being filtered from the new filter
      const newFilterFields = new Set();
      if (filter && filter.length > 0) {
        filter.forEach(filterItem => {
          if (filterItem.filters) {
            filterItem.filters.forEach(innerFilter => {
              if (innerFilter.field) {
                newFilterFields.add(innerFilter.field);
              }
            });
          } else if (filterItem.field) {
            newFilterFields.add(filterItem.field);
          }
        });
      }

      // Remove any existing filters for the same fields
      let filteredExisting = existingFilter.filter(item => {
        // For filters with nested filters array
        if (item.filters) {
          return !item.filters.some(innerFilter =>
            innerFilter.field && newFilterFields.has(innerFilter.field)
          );
        }
        // For direct filters
        return !(item.field && newFilterFields.has(item.field));
      });

      // Combine filtered existing filters with new filters
      let combinedFilters = [...filteredExisting, ...filter];

      // Deduplicate the combined filters
      const uniqueFilters = new Set();
      const dedupedFilters = [];

      for (const filterItem of combinedFilters) {
        const filterStr = JSON.stringify(filterItem);
        if (!uniqueFilters.has(filterStr)) {
          uniqueFilters.add(filterStr);
          dedupedFilters.push(filterItem);
        }
      }
      const result = filterBy(this.props.taskDataList, dedupedFilters);
      // if (result && result.length > 0) {
      await this.createDynamicDropdowns(result, dedupedFilters);
      //   await this.createDynamicCols(result, arr);
      //   await this.checkRisktypeSelections(arr);
      // }

      var taskDataList = result.map((dataItem) =>
        Object.assign({ selected: false }, dataItem)
      );
      this.setState({
        ...this.state,
        taskDataList: taskDataList,
        existingFilter: dedupedFilters,
        take: Math.round((window.innerHeight - 250) / 35),
        sort: [],
        filter: {
          logic: "and",
          filters: dedupedFilters,
        },
        skip: 0,
      });
      this.saveSelectedIds([]);
      // this.props.mitigationFilterQuery(arr);
    } else if (e.nativeEvent.type == "reset") {
      let exi = [];
      if (this.state.existingFilter) {
        let filterData = this.state.existingFilter;
        filterData.forEach((filter2) => {
          if (filter2.filters) {
            // Only add the filter if none of its inner filters match the selected column
            const hasMatchingInnerFilter = filter2.filters.some(
              innerFilter => innerFilter.field === this.state.selectedColumn
            );
            if (!hasMatchingInnerFilter) {
              exi.push(filter2);
            }
          } else {
            if (filter2.field != this.state.selectedColumn) {
              exi.push(filter2);
            }
          }
        });
      }
      const result = filterBy(this.props.taskDataListTemp, exi);
      await this.createDynamicDropdowns(result, exi);
      // await this.createDynamicCols(result, exi);
      // await this.checkRisktypeSelections(exi);
      var taskDataList = result.map((dataItem) =>
        Object.assign({ selected: false }, dataItem)
      );
      this.setState({
        ...this.state,
        taskDataList: taskDataList,
        existingFilter: exi,
        take: Math.round((window.innerHeight - 250) / 35),
        skip: 0,
        sort: [],
        filter: {
          logic: "and",
          filters: exi,
        },
      });
      this.saveSelectedIds([]);
      // this.props.mitigationFilterQuery(exi);
    }
  };
  setClassName = (field) => {
    let headerClassName = "";
    if (this.state.filter && this.state.filter.filters) {
      this.state.filter.filters.map((filter) => {
        if (filter.field === field) {
          headerClassName = "active";
        }
        if (filter.filters) {
          filter.filters.map((innerFilter) => {
            if (innerFilter.field === field) {
              headerClassName = "active";
            }
          });
        }
      });
    }
    return headerClassName;
  };

  dataStateChange = (event) => {
    this.setState(this.createAppState(event.dataState));
    // this.props.mitigationFilterQuery(event.dataState);
  };

  createAppState = (dataState) => {
    if (this.state && this.state.taskDataListTemp) {
      return {
        taskDataList: this.state.taskDataListTemp.slice(0),
        dataState: dataState,
      };
    } else {
      return {
        taskDataList: [],
        dataState: dataState,
      };
    }
  };
  onEditCell = () => {};
  render() {
    const data = this.props.taskDataList;

    return (
      <div
        className="tblCont riskRegister dataGrids reportsGrid"
        id="reportaction"
      >
        {/* <div className="tblCont riskRegister dataGrids ActionTbl"> */}

        <Grid
          data={process(this.state.taskDataList, this.state.dataState)}
          {...this.state.dataState}
          onDataStateChange={this.dataStateChange}
          reorderable
          resizable
          sortable={true}
          pageable={true}
          // onPageChange={this.pageChange}
          // total={this.state.taskDataList.length}
          onFilterChange={this.filterChangeExisting}
          filter={this.state.filter}
        >
          <GridNoRecords>
            Associated Dataset's Custom fields might been deleted or revoked
          </GridNoRecords>
          <Column
            field="organizationUnitName"
            title="Workstream"
            width="200px"
            columnMenu={(props) => (
              <ColumnMenuFilterForTask
                {...props}
                getSelectedColumn={this.getSelectedColumn}
              />
            )}
            headerClassName={this.setClassName("organizationUnitName")}
          />
          <Column
            field="taskActionNumber"
            title="Activity Number"
            width="200px"
            columnMenu={(props) => (
              <ColumnMenuFilterForTask
                {...props}
                getSelectedColumn={this.getSelectedColumn}
              />
            )}
            headerClassName={this.setClassName("taskActionNumber")}
          />
          <Column
            field="isApproved"
            title="Approved"
            width="200px"
            columnMenu={(props) => (
              <ColumnMenuCheckboxFilter
                {...props}
                data={this.state.taskDataList}
                getSelectedColumn={this.getSelectedColumn}
              />
            )}
            headerClassName={this.setClassName("isApproved")}
          />
          <Column
            field="taskActionTitle"
            title="Activity Title"
            width="200px"
            columnMenu={(props) => (
              <ColumnMenuFilterForTask
                {...props}
                getSelectedColumn={this.getSelectedColumn}
              />
            )}
            headerClassName={this.setClassName("taskActionTitle")}
          />
          <Column
            field="taskActionDescription"
            title="Activity Description"
            width="200px"
            columnMenu={(props) => (
              <ColumnMenuFilterForTask
                {...props}
                getSelectedColumn={this.getSelectedColumn}
              />
            )}
            headerClassName={this.setClassName("taskDescription")}
          />
          <Column
            field="cost"
            title={
              "Cost of Activity" + " (" + secureLocalStorage.getItem("currency") + ")"
            }
            width="200px"
            filter={"numeric"}
            columnMenu={(props) => (
              <ColumnMenuFilterForTask
                {...props}
                getSelectedColumn={this.getSelectedColumn}
              />
            )}
            headerClassName={this.setClassName("")}
          />
          <Column
            field="effort"
            title={"Effort" + " (Days)"}
            filter={"numeric"}
            width="200px"
            columnMenu={(props) => (
              <ColumnMenuFilterForTask
                {...props}
                getSelectedColumn={this.getSelectedColumn}
              />
            )}
            headerClassName={this.setClassName("effort")}
          />
          <Column
            field="percentageOnTrack"
            title="% on Track"
            width="200px"
            filter={"numeric"}
            columnMenu={(props) => (
              <ColumnMenuFilterForTask
                {...props}
                getSelectedColumn={this.getSelectedColumn}
              />
            )}
            headerClassName={this.setClassName("percentageOnTrack")}
          />
          <Column
            field="percentageCompletion"
            title="% Completion"
            width="200px"
            filter={"numeric"}
            columnMenu={(props) => (
              <ColumnMenuFilterForTask
                {...props}
                getSelectedColumn={this.getSelectedColumn}
              />
            )}
            headerClassName={this.setClassName("percentageCompletion")}
          />
          <Column
            field="priorityRankingName"
            title="Priority Ranking"
            width="200px"
            columnMenu={(props) => (
              <ColumnMenuCheckboxFilter
                {...props}
                data={this.state.taskDataList}
                getSelectedColumn={this.getSelectedColumn}
              />
            )}
            headerClassName={this.setClassName("priorityRankingName")}
          />
        <Column
                      field="priorityScore"
                      title="Weighted Priority"
                      width="200px"
                      filter={"numeric"}
                      columnMenu={(props) => (
                        <ColumnMenuFilterForTask
                          {...props}
                          getSelectedColumn={this.getSelectedColumn}
                        />
                      )}
                      headerClassName={this.setClassName("priorityScore")}
                    />
                    <Column
                      field="progressComment"
                      title="progress Status"
                      width="200px"
                      cell={(props) => (
                        <td title={props.dataItem.progressComment}>
                            {props.dataItem.progressComment}
                        </td>
                      )}
                   />
          {this.state.dropdownColumns}
          <Column
            field="originalCompletionDate"
            title="Original Completion Date"
            width="200px"
            filter={"date"}
            format="{0:dd-MMM-yyyy}"
            columnMenu={(props) => (
              <ColumnMenuFilterForTask
                {...props}
                getSelectedColumn={this.getSelectedColumn}
              />
            )}
            headerClassName={this.setClassName("originalCompletionDate")}
          />
          <Column
            field="projectedCompletionDate"
            title="Projected Completion Date"
            width="200px"
            filter={"date"}
            format="{0:dd-MMM-yyyy}"
            columnMenu={(props) => (
              <ColumnMenuFilterForTask
                {...props}
                getSelectedColumn={this.getSelectedColumn}
              />
            )}
            headerClassName={this.setClassName("projectedCompletionDate")}
          />
          <Column
            field="actualCompletionDate"
            title="Actual Completion Date"
            width="200px"
            filter={"date"}
            format="{0:dd-MMM-yyyy}"
            columnMenu={(props) => (
              <ColumnMenuFilterForTask
                {...props}
                getSelectedColumn={this.getSelectedColumn}
              />
            )}
            headerClassName={this.setClassName("actualCompletionDate")}
          />
          <Column
            field="proximityAlertDate"
            title="Proximity Alert Date"
            width="200px"
            format="{0:dd-MMM-yyyy}"
            filter={"date"}
            columnMenu={(props) => (
              <ColumnMenuFilterForTask
                {...props}
                getSelectedColumn={this.getSelectedColumn}
              />
            )}
            headerClassName={this.setClassName("proximityAlertDate")}
          />
          <Column
                        field="daysOverdue"
                        title="Original Days Overdue"
                        width="120px"
                        editable={false}
                        filter={"numeric"}
                        columnMenu={(props) => (
                          <ColumnMenuFilterForTask
                            {...props}
                            getSelectedColumn={this.getSelectedColumn}
                          />
                        )}
                        headerClassName={this.setClassName("daysOverdue")}
                      />
                      <Column
                        field="projectedDaysOverdue"
                        title="Projected Days Overdue"
                        width="120px"
                        editable={false}
                        filter={"numeric"}
                        columnMenu={(props) => (
                          <ColumnMenuFilterForTask
                            {...props}
                            getSelectedColumn={this.getSelectedColumn}
                          />
                        )}
                        headerClassName={this.setClassName("projectedDaysOverdue")}
                      />
          {/* <Column
            field="delayConsequence"
            title="Delay Consequence"
            width="200px"
            columnMenu={(props) => (
              <ColumnMenuFilterForTask
                {...props}
                getSelectedColumn={this.getSelectedColumn}
              />
            )}
            headerClassName={this.setClassName("delayConsequence")}
          />
          <Column
            field="alertStakeHolders"
            title="Alert Stakeholders"
            width="200px"
            columnMenu={(props) => (
              <ColumnMenuFilterForTask
                {...props}
                getSelectedColumn={this.getSelectedColumn}
              />
            )}
            headerClassName={this.setClassName("alertStakeHolders")}
          />
          <Column
            field="alertDescription"
            title="Alert Description"
            width="200px"
            columnMenu={(props) => (
              <ColumnMenuFilterForTask
                {...props}
                getSelectedColumn={this.getSelectedColumn}
              />
            )}
            headerClassName={this.setClassName("alertDescription")}
          /> */}
          <Column
            field="ownerName"
            title="Activity Owner"
            width="200px"
            columnMenu={(props) => (
              <ColumnMenuCheckboxFilter
                {...props}
                data={this.state.taskDataList}
                getSelectedColumn={this.getSelectedColumn}
              />
            )}
            headerClassName={this.setClassName("taskOwnerName")}
          />
          <Column
                        field="taskActionFieldCompletion"
                        title="% of fields completed"
                        width="120px"
                        editable={false}
                        filter={"numeric"}
                        columnMenu={(props) => (
                          <ColumnMenuFilterForTask
                            {...props}
                            getSelectedColumn={this.getSelectedColumn}
                          />
                        )}
                        headerClassName={this.setClassName("taskActionFieldCompletion")}
                      />
          <Column
            field="createdDate"
            title="Created Date"
            width="200px"
            filter={"date"}
            format="{0:dd-MMM-yyyy}"
            columnMenu={(props) => (
              <ColumnMenuFilterForTask
                {...props}
                getSelectedColumn={this.getSelectedColumn}
              />
            )}
            headerClassName={this.setClassName("createdDate")}
          />
          <Column
            field="createdByName"
            title="Created By"
            width="200px"
            columnMenu={(props) => (
              <ColumnMenuCheckboxFilter
                {...props}
                data={this.state.taskDataList}
                getSelectedColumn={this.getSelectedColumn}
              />
            )}
            headerClassName={this.setClassName("createdByName")}
          />
          <Column
            field="updatedDate"
            title="Updated Date"
            width="200px"
            format="{0:dd-MMM-yyyy}"
            filter={"date"}
            columnMenu={(props) => (
              <ColumnMenuFilterForTask
                {...props}
                getSelectedColumn={this.getSelectedColumn}
              />
            )}
            headerClassName={this.setClassName("updatedDate")}
          />
          <Column
            field="updatedByName"
            title="Updated By"
            width="200px"
            columnMenu={(props) => (
              <ColumnMenuCheckboxFilter
                {...props}
                data={this.state.taskDataList}
                getSelectedColumn={this.getSelectedColumn}
              />
            )}
            headerClassName={this.setClassName("updatedByName")}
          />
          <Column
            field="closedDate"
            title="Closed Date"
            width="200px"
            filter={"date"}
            format="{0:dd-MMM-yyyy}"
            columnMenu={(props) => (
              <ColumnMenuFilterForTask
                {...props}
                getSelectedColumn={this.getSelectedColumn}
              />
            )}
            headerClassName={this.setClassName("")}
          />
          <Column
            field="isClosed"
            title="Status"
            width="200px"
            columnMenu={(props) => (
              <ColumnMenuCheckboxFilter
                {...props}
                data={this.state.taskDataList}
                getSelectedColumn={this.getSelectedColumn}
              />
            )}
            headerClassName={this.setClassName("isClosed")}
          />
          <Column
            field="departments"
            title="Departments"
            width="150px"
            columnMenu={(props) => (
              <ColumnMenuFilterForTask
                {...props}
                getSelectedColumn={this.getSelectedColumn}
              />
            )}
            headerClassName={this.setClassName("progressComment")}
          />
          <Column
            field="externalStatus"
            title="External Status"
            width="120px"
            columnMenu={(props) => (
              <ColumnMenuFilterForTask
                {...props}
                getSelectedColumn={this.getSelectedColumn}
              />
            )}
            headerClassName={this.setClassName("progressComment")}
          />
          <Column
            field="weeklyReport"
            title="Weekly Report"
            width="100px"
            columnMenu={(props) => (
              <ColumnMenuFilterForTask
                {...props}
                getSelectedColumn={this.getSelectedColumn}
              />
            )}
            headerClassName={this.setClassName("progressComment")}
          />
        </Grid>
        {/* </div> */}
      </div>
    );
  }
}
